import PropTypes from 'prop-types';
import React from 'react';

class Error extends React.Component {
  static get propTypes() {
    return {
      routes: PropTypes.array,
      location: PropTypes.object,
    };
  }

  render() {
    return this.props.location.state != null &&
      this.props.location.state.message != null
      ? this.props.location.state.message
      : 'Internal Server Error';
  }
}

export default Error;
